import type { Locale } from "../../../shared/I18n";

export function makeVJJsonUrl(
  original: string,
  locale: Locale | null,
  prforceGroups: string | null,
): string {
  const urlObj = new URL(original);
  urlObj.searchParams.set("spa", "1");
  urlObj.searchParams.set("viewtype", "native");

  // force the https protocol, some viewjob urls might be mistakenly http
  urlObj.protocol = "https:";

  if (locale) {
    urlObj.searchParams.set("hl", locale.language);
    if (locale.country) {
      urlObj.searchParams.set("co", locale.country);
    }
  }

  // Assume there is no prforceGroups in the original URL
  if (typeof prforceGroups === "string" && prforceGroups.length > 0) {
    urlObj.searchParams.set("prforceGroups", prforceGroups);
  }

  return urlObj.toString();
}
